import { type Language, SUPPORTED_LANGUAGES } from '@inflearn/i18n-tools';
import { useTranslation } from 'next-i18next';
import type { GetServerSidePropsContext } from 'next/types';
import { getCdnTranslationProps } from '../../../utils/server/i18n/getCdnTranslationProps';

import PolicyLayout from '../../../components/layout/PolicyLayout';
import { PolicyContent } from '../../../components/pages/policy/PolicyContent';
import { HAS_GUIDE_LANG } from '../../../utils/i18n/hasGuideLang';

export const getStaticProps = async (context: GetServerSidePropsContext) => {
  const locale = context.locale as Language;
  const revalidateTime = 60;

  if (HAS_GUIDE_LANG.includes(locale)) {
    return {
      props: {
        ...(await getCdnTranslationProps(locale, ['common'])),
      },
      revalidate: revalidateTime,
    };
  }

  return {
    props: {
      ...(await getCdnTranslationProps(SUPPORTED_LANGUAGES.en, ['common'])),
    },
    revalidate: revalidateTime,
  };
};

export default function PolicyPreviousPrivacyPage() {
  const { t } = useTranslation();

  return (
    <PolicyLayout
      meta={{
        title: '메타.이전개인정보처리방침.제목',
        description: '메타.이전개인정보처리방침.설명',
      }}
    >
      <PolicyContent
        title={t('개인정보 처리방침')}
        prevPolicy={{
          href: '/policy/privacy',
          description: t('메타.이전개인정보처리방침.설명'),
        }}
        type="PRIVACY"
        period="PREVIOUS"
      />
    </PolicyLayout>
  );
}
